import { render, staticRenderFns } from "./Toolbar2.vue?vue&type=template&id=5e54153d&scoped=true&"
import script from "./Toolbar2.vue?vue&type=script&lang=js&"
export * from "./Toolbar2.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar2.vue?vue&type=style&index=0&id=5e54153d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e54153d",
  null
  
)

export default component.exports